import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }
const _hoisted_4 = { style: {"margin-bottom":"-15px","margin-left":"-10px","margin-top":"-5px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-0" }, "Total Sales", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-select month-select form-control",
          "aria-label": "Default select example",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTimeFrame) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeSalesData && _ctx.changeSalesData(...args)))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("option", { value: "Monthly" }, "Monthly", -1),
          _createElementVNode("option", { value: "Weekly" }, "Weekly", -1),
          _createElementVNode("option", { value: "Today" }, "Today", -1),
          _createElementVNode("option", { value: "Yearly" }, "Yearly", -1)
        ]), 544), [
          [_vModelSelect, _ctx.selectedTimeFrame]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "365",
              options: _ctx.totalSales,
              series: _ctx.sales
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}